import React from "react";

const NO_TRANSLATE_CLASS = "notranslate";

export const noTranslateProps = {
  className: NO_TRANSLATE_CLASS,
  translate: "no" as const,
  "data-gt-ignore": "true" as const,
};

const mergeNoTranslateClassName = (className?: string) => {
  if (!className) {
    return NO_TRANSLATE_CLASS;
  }
  const classes = className.split(/\s+/);
  return classes.includes(NO_TRANSLATE_CLASS)
    ? className
    : `${NO_TRANSLATE_CLASS} ${className}`.trim();
};

type NoTranslateProps = {
  children: React.ReactNode;
  as?: React.ElementType;
  className?: string;
  [key: string]: any;
};

const NoTranslate = ({
  children,
  as: Component = "span",
  className,
  ...props
}: NoTranslateProps) => {
  return (
    <Component
      {...props}
      className={mergeNoTranslateClassName(className)}
      translate="no"
      data-gt-ignore="true"
    >
      {children}
    </Component>
  );
};

export default NoTranslate;
